export { default } from './ModulDestacatVisual';
